import { render } from "./InfoPanelTrendChart.vue?vue&type=template&id=52a2716e&scoped=true&lang=html"
import script from "./InfoPanelTrendChart.vue?vue&type=script&lang=js"
export * from "./InfoPanelTrendChart.vue?vue&type=script&lang=js"

import "./InfoPanelTrendChart.vue?vue&type=style&index=0&id=52a2716e&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a2716e"]])

export default __exports__